module.exports = __webpack_public_path__ + "img/mallikuva3.ae96753a.jpg";